module.exports = __webpack_public_path__ + "img/clock.b2c44903.svg";